import { h } from 'preact'
import { useState, useEffect, useRef, useCallback } from 'preact/hooks'
import translate from 'app/core/translate'
import { useSelector } from 'react-redux'
import { pagingFilteringContextSelector } from 'core/state/page/pageSelectors'
import withSearch from 'features/elastic/core/withSearch'

function SortFacet({ setOrderBy }) {
    const { availableSortOptions } = useSelector(pagingFilteringContextSelector)
    const [open, setOpen] = useState(false)
    const ref = useRef(null)

    const optionIds = availableSortOptions.map(option => option.value)

    function handleFacetPress() {
        setOpen(!open)
    }

    const validate = useCallback(value => setOrderBy(Number(value)), [setOrderBy])

    function handleOptionCheck({ target }) {
        target.checked = true

        optionIds.forEach(optionId => {
            if (optionId !== target.id) {
                document.getElementById(optionId).checked = false
            }
        })

        validate(Number(target.value))
    }

    useEffect(() => {
        function windowClickEvent(e) {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(!open)
            }
        }

        if (open) {
            window.addEventListener('click', windowClickEvent)
        }

        return () => {
            window.removeEventListener('click', windowClickEvent)
        }
    }, [open, ref])

    return (
        <li ref={ref}>
            <div
                className={`wsu-facet-label ${open ? 'open' : ''}`}
                onClick={handleFacetPress}
            >
                <div class="facet-label-row">
                    <span>{translate('catalog.orderBy')}</span>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.36612 16.1161C7.87796 16.6043 7.87796 17.3957 8.36612 17.8839L23.1161 32.6339C23.6043 33.122 24.3957 33.122 24.8839 32.6339L39.6339 17.8839C40.122 17.3957 40.122 16.6043 39.6339 16.1161C39.1457 15.628 38.3543 15.628 37.8661 16.1161L24 29.9822L10.1339 16.1161C9.64573 15.628 8.85427 15.628 8.36612 16.1161Z"
                            fill="var(--md-gray-950)"
                        />
                    </svg>
                </div>
            </div>
            {open && (
                <div class="wsu-dropdown">
                    <ul class="wsu-facet">
                        {availableSortOptions.map(
                            ({ selected, disabled, value, text }, index) => (
                                <li
                                    key={value}
                                    className={disabled ? 'disabled' : ''}
                                >
                                    <label htmlFor={optionIds[index]}>
                                        <div class="wsu-checkbox-wrapper">
                                            <input
                                                type="checkbox"
                                                id={optionIds[index]}
                                                onChange={handleOptionCheck}
                                                defaultChecked={selected}
                                                disabled={disabled}
                                                value={value}
                                            />
                                            <span class="wsu-checkbox-label">
                                                {text}
                                            </span>
                                        </div>
                                    </label>
                                </li>
                            ),
                        )}
                    </ul>
                </div>
            )}
        </li>
    )
}

export default withSearch(({ setOrderBy }) => ({ setOrderBy }))(SortFacet)
